import { Field as FormikField, getIn } from 'formik';
import { nanoid } from 'nanoid';
import React from 'react';
import styled from 'styled-components';

/**
 * @deprecated use FormControl from '@frontend/legacy-components' instead.
 */
const FieldContext = React.createContext({
  error: false,
});

/**
 * @deprecated use form components from '@frontend/legacy-components' instead.
 */
const Group = styled.div`
  ${(props) =>
    props.layout === 'vertical' &&
    `
  > *:not(:last-child) {
    margin-bottom: 8px;
  }
`} ${(props) =>
    props.layout === 'horizontal' &&
    `
display: flex;
& > *:not(:last-child) {
    padding-right: 20px;
}
`};
`;

Group.defaultProps = {
  layout: 'vertical',
};

const FieldMessage = styled.div`
  color: ${(props) => (props.isError ? 'red' : 'green')};
  font-size: 12px;
  line-height: 1.5;
`;

const StyledField = styled.div`
  width: 100%;

  ${(props) =>
    props.grow !== undefined &&
    `
    flex: ${props.grow} 0 0;
  `};

  > label {
    display: block;
    color: #828282;
    font-size: 12px;
    letter-spacing: 0.8px;
    text-transform: uppercase;
    line-height: 15px;
    padding-top: 5px;
    padding-bottom: 2px;
    ${(props) =>
      props.required &&
      `
      ::after {
        content: ' *';
        color: red;
      }`} ${(props) =>
      !props.showLabel &&
      `
    visibility: hidden;
  `};
  }
`;

/**
 * @deprecated use FormControl and other form components from
 * '@frontend/legacy-components' instead.
 */
class Field extends React.Component {
  constructor(props) {
    super(props);
    this.id = 'input-' + nanoid();
  }

  render() {
    const {
      className,
      grow,
      label,
      showLabel = true,
      required = false,
      error,
      hint,
      children,
    } = this.props;
    return (
      <FieldContext.Provider value={{ error: !!error }}>
        <StyledField
          data-testid="select-options"
          className={className}
          grow={grow}
          showLabel={showLabel}
          required={required}
        >
          {label && <label htmlFor={this.id}>{label}</label>}
          {React.Children.count(children) === 1
            ? React.cloneElement(React.Children.only(children), { id: this.id })
            : children}
          {error || hint ? (
            <FieldMessage isError={!!error}>
              {typeof error === 'function'
                ? error()
                : typeof hint === 'function'
                ? hint()
                : error || hint}
            </FieldMessage>
          ) : null}
        </StyledField>
      </FieldContext.Provider>
    );
  }
}

/**
 * @deprecated use FormErrorMessage from '@frontend/legacy-components' instead.
 */
const ErrorMessage = ({ name, showAlways }) => {
  return (
    <FormikField name={name}>
      {({ form }) => {
        const error = getIn(form.errors, name);
        const touch = getIn(form.touched, name);
        return (showAlways || touch) && error ? error : null;
      }}
    </FormikField>
  );
};

export default {
  FieldContext,
  Field,
  Group,
  ErrorMessage,
};
